import {
  IonCheckbox,
  IonItem,
  IonLabel,
  IonText,
  IonToggle,
} from '@ionic/react';
import React, { useState } from 'react';
import style from './build-item-select.module.scss';

interface Item {
  name: string;
  _uid?: string;
  [key: string]: any;
}

interface BuildGenresProps {
  items: Item[];
  onSelectedItemsChange: (selected: Item[]) => void;
  selectionType: 'toggle' | 'checkbox';
  limit?: number;
}

export default function BuildItemSelect({
  items,
  onSelectedItemsChange,
  selectionType,
  limit,
}: BuildGenresProps) {
  const [selectedItems, setSelectedItems] = useState<Item[]>([]);

  const hasReachedLimit = limit && selectedItems.length >= limit;

  const getItemId = (item: Item, index: number): string => {
    return item._uid || `${item.name}_${index}`;
  };

  const isItemSelected = (item: Item, index: number): boolean => {
    const itemId = getItemId(item, index);
    return selectedItems.some(
      (si, siIndex) => getItemId(si, siIndex) === itemId,
    );
  };

  return (
    <div style={{ height: '400px', overflowX: 'scroll' }}>
      {hasReachedLimit && (
        <IonText color="danger">Max selections has been reached.</IonText>
      )}
      {items.map((item, index) => (
        <IonItem key={getItemId(item, index)}>
          {selectionType === 'toggle' ? (
            <IonToggle
              slot="start"
              disabled={!!(hasReachedLimit && !isItemSelected(item, index))}
              checked={isItemSelected(item, index)}
              onIonChange={(e) =>
                handleSelectionChange(item, index, e.detail.checked)
              }
              className={style['build-item-option']}
              aria-label={item.name}
            />
          ) : (
            <IonCheckbox
              slot="start"
              disabled={!!(hasReachedLimit && !isItemSelected(item, index))}
              checked={isItemSelected(item, index)}
              onIonChange={(e) =>
                handleSelectionChange(item, index, e.detail.checked)
              }
              className={style['build-item-option']}
              aria-label={item.name}
            />
          )}
          <IonLabel>{item.name}</IonLabel>
        </IonItem>
      ))}
    </div>
  );

  function handleSelectionChange(
    item: Item,
    index: number,
    isChecked: boolean,
  ) {
    let newSelectedItems;
    const itemId = getItemId(item, index);

    if (isChecked) {
      if (limit && selectedItems.length >= limit) {
        return;
      }
      newSelectedItems = [...selectedItems, item];
    } else {
      newSelectedItems = selectedItems.filter((selectedItem, selectedIndex) => {
        const selectedItemId = getItemId(selectedItem, selectedIndex);
        return selectedItemId !== itemId;
      });
    }

    setSelectedItems(newSelectedItems);
    onSelectedItemsChange(newSelectedItems);
  }
}
